import { render, staticRenderFns } from "./activitySetup.html?vue&type=template&id=3d4b21c8&scoped=true&external"
import script from "./activitySetup.vue?vue&type=script&lang=js"
export * from "./activitySetup.vue?vue&type=script&lang=js"
import style0 from "./activitySetup.css?vue&type=style&index=0&id=3d4b21c8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b21c8",
  null
  
)

export default component.exports